module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9e8.a6602955.svg";